import context from '../../config/context'
import {
  BREACHED_PASSWORD_MESSAGE,
  CURRENT_PASSWORD_DOESNT_MATCH_MESSAGE,
  DIFFERENT_PASSWORDS_ERROR_MESSAGE,
  GENERIC_PASSWORD_CHANGE_ERROR,
  INVALID_RESET_TOKEN_ERROR_PART_1,
  INVALID_RESET_TOKEN_ERROR_PART_2,
  LOW_QUALITY_PASSWORD_ERROR_PART_1,
  NEED_HELP,
} from '../../constants/ui.labels'
import {
  BREACHED_PASSWORD_CODE,
  CURRENT_PASSWORD_DOESNT_MATCH_CODE,
  DIFFERENT_PASSWORDS_CODE,
  GENERIC_PASSWORD_CHANGE_CODE,
  INVALID_RESET_TOKEN_CODE,
  LOW_QUALITY_PASSWORD_CODE,
  PASSWORD_NOT_COMPLIANT_CODE,
} from '../../constants/error.codes'
import {
  CHANGE_PASSWORD_HELP,
  PASSWORD_RESET,
} from '../../constants/accountRecoveryLinks'
import PasswordPolicies from '../../components/PasswordPolicies'
import Link from '@talkdesk/cobalt-react-link'
import Flex from '@talkdesk/cobalt-react-flex'

const lowQualityPassword = () => (
  <Flex direction='column' gap='2'>
    {LOW_QUALITY_PASSWORD_ERROR_PART_1}{' '}
    <Link target='_blank' href={CHANGE_PASSWORD_HELP}>
      {NEED_HELP}
    </Link>
  </Flex>
)

const notCompliantPassword = () => (
  <PasswordPolicies
    isError={true}
    passwordPolicies={context.passwordPolicies}
  />
)

export default (code, genericMessage) => {
  return (
    {
      [CURRENT_PASSWORD_DOESNT_MATCH_CODE]:
        CURRENT_PASSWORD_DOESNT_MATCH_MESSAGE,
      [DIFFERENT_PASSWORDS_CODE]: DIFFERENT_PASSWORDS_ERROR_MESSAGE,
      [GENERIC_PASSWORD_CHANGE_CODE]: GENERIC_PASSWORD_CHANGE_ERROR,
      [INVALID_RESET_TOKEN_CODE]: (
        <Flex direction='column' gap='2'>
          {INVALID_RESET_TOKEN_ERROR_PART_1}
          <Link href={PASSWORD_RESET}>{INVALID_RESET_TOKEN_ERROR_PART_2}</Link>
        </Flex>
      ),
      [LOW_QUALITY_PASSWORD_CODE]: lowQualityPassword(),
      [PASSWORD_NOT_COMPLIANT_CODE]: notCompliantPassword(),
      [BREACHED_PASSWORD_CODE]: BREACHED_PASSWORD_MESSAGE,
    }[code] || genericMessage
  )
}
